var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 2.99992H9.66732V1.66659C9.66732 0.926585 9.07398 0.333252 8.33398 0.333252H5.66732C4.92732 0.333252 4.33398 0.926585 4.33398 1.66659V2.99992H1.66732C0.927318 2.99992 0.340651 3.59325 0.340651 4.33325L0.333984 11.6666C0.333984 12.4066 0.927318 12.9999 1.66732 12.9999H12.334C13.074 12.9999 13.6673 12.4066 13.6673 11.6666V4.33325C13.6673 3.59325 13.074 2.99992 12.334 2.99992ZM5.66732 1.66659H8.33398V2.99992H5.66732V1.66659ZM12.334 11.6666H1.66732V4.33325H12.334V11.6666Z",
    fill: "#1E456A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.e184b1df242aa16bbc4b84a4dca00050.svg";
export { ForwardRef as ReactComponent };